import React, { useCallback, useLayoutEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { REGISTERED_BUS_FLEET_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  clearRegisteredBusFleets,
  getCurrentStatusRegisteredBusFleets,
} from '../../../../actions';
import Content from '../../../layout/Content';
import RegisteredBusFleetToolbar from './RegisteredBusFleetToolbar';
import BusFleetCurrentStatusPanel from './BusFleetCurrentStatusPanel';
import BusFleetHistoryPanel from './BusFleetHistoryPanel';

const CURRENT_STATUS_TAB = 'CURRENT_STATUS';
const HISTORY_TAB = 'HISTORY';

const CURRENT_STATUS_INITIAL_FILTERS = {
  showNorthChico: false,
  showMine: false,
};

const RegisteredBusFleets = ({
  breadcrumbs,
  dispatchClearRegisteredBusFleets,
  dispatchGetCurrentStatusRegisteredBusFleets,
}) => {
  const [activeTab, setActiveTab] = useState(CURRENT_STATUS_TAB);
  const [currentStatusFilters, setCurrentStatusFilters] = useState(
    CURRENT_STATUS_INITIAL_FILTERS,
  );

  useLayoutEffect(() => {
    dispatchGetCurrentStatusRegisteredBusFleets(CURRENT_STATUS_INITIAL_FILTERS);

    return () => dispatchClearRegisteredBusFleets();
  }, []);

  const handleRefreshCurrentStatus = useCallback(() => {
    dispatchGetCurrentStatusRegisteredBusFleets(currentStatusFilters);
  }, [currentStatusFilters]);

  const handleSearchCurrentStatus = (filters) => {
    setCurrentStatusFilters(filters);
    dispatchGetCurrentStatusRegisteredBusFleets(filters);
  };

  const toolbar = (
    <RegisteredBusFleetToolbar onSuccess={handleRefreshCurrentStatus} />
  );

  const content = (
    <>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={activeTab === CURRENT_STATUS_TAB ? 'active' : ''}
            onClick={() => setActiveTab(CURRENT_STATUS_TAB)}
            style={{ cursor: 'pointer' }}
          >
            Estado Actual
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === HISTORY_TAB ? 'active' : ''}
            onClick={() => setActiveTab(HISTORY_TAB)}
            style={{ cursor: 'pointer' }}
          >
            Histórico
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="pt-3">
        <TabPane tabId={CURRENT_STATUS_TAB}>
          <BusFleetCurrentStatusPanel
            initialFilters={CURRENT_STATUS_INITIAL_FILTERS}
            onSearch={handleSearchCurrentStatus}
            onRefresh={handleRefreshCurrentStatus}
          />
        </TabPane>
        <TabPane tabId={HISTORY_TAB}>
          <BusFleetHistoryPanel />
        </TabPane>
      </TabContent>
    </>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Flota de Buses Programación"
      content={content}
    />
  );
};

RegisteredBusFleets.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearRegisteredBusFleets: PropTypes.func.isRequired,
  dispatchGetCurrentStatusRegisteredBusFleets: PropTypes.func.isRequired,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Flota de Buses',
      href: REGISTERED_BUS_FLEET_PATH,
    },
  ],
});

const mapDispatchToProps = {
  dispatchClearRegisteredBusFleets: clearRegisteredBusFleets,
  dispatchGetCurrentStatusRegisteredBusFleets:
    getCurrentStatusRegisteredBusFleets,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegisteredBusFleets);
